<template>
  <div class="calendar">
    <WeekWithDays />
    <div class="periods" v-if="showPeriods">
      <Horizontal :itemID="periodRoot._id" />
    </div>
  </div>
</template>

<style scoped>
.calendar {
  display: flex;
  flex-direction: row;
  flex: auto;
}

.periods {
  margin-top: 16px;

  border-radius: var(--rounding-larger);
  background: #fffdf477;
  padding: var(--basic-padding);
  border: var(--list-border);
}

.periods::v-deep .heading {
  margin-bottom: 8px;
}

.main-panel .periods::v-deep .callToAction {
  background-color: transparent;
}
</style>

<script>
import { getItem } from "@/reactive-cache";
import Horizontal from "./horizontal.vue";
import WeekWithDays from "@/components/WeekWithDays.vue";
import ItemHeader from "@/components/ItemHeader.vue";
import settings from "@/synced-settings";

export default {
  components: {
    Horizontal,
    WeekWithDays,
    ItemHeader,
  },
  computed: {
    periodRoot() {
      return getItem("root:period");
    },
    showPeriods() {
      return this.periodRoot.getChildren().length > 0 && settings.periodsInCal;
    },
  },
  methods: {},
};
</script>
